import { Button } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { useTranslation } from 'react-i18next';

import { AliasAddForm } from '@/module/Dashboard/components/AliasAddForm';
import { useAddAlias } from '@/module/Dashboard/model/DashboardQuery';
import { ChangeAliasRequest } from '@/module/Dashboard/model/DashboardTypes';

import { useFreezeDate } from '@/feature/utils/hooks/useFreezeDate';
import { useAppNotification } from '@feature/utils';

export function AliasAddButton() {
  const { mutate, isPending } = useAddAlias();
  const { t } = useTranslation();
  const [opened, { open, close }] = useDisclosure(false);
  const notification = useAppNotification();
  const { isAfterFreezeDate } = useFreezeDate();

  const handleChange = (request: ChangeAliasRequest) =>
    mutate(request, {
      onError: notification.error,
      onSuccess: () => {
        notification.success();
        close();
      },
    });

  return (
    <>
      <Button
        size="xs"
        variant="outline"
        loading={isPending}
        onClick={open}
        disabled={isAfterFreezeDate}
      >
        {t('profile.addAlias')}
      </Button>
      {opened && (
        <AliasAddForm
          onClose={close}
          isSubmitting={isPending}
          onChange={handleChange}
        />
      )}
    </>
  );
}
